import { Role } from "@/enums";

/**
 * Classe che rappresenta un ruolo attivo dell'utente.
 */
export class RoleWrapper {
  /**
   * @param {number} role - Il valore del ruolo in formato intero
   */
  constructor(role) {
    this.role = role;
  }

  /**
   * Verifica se l'utente ha un determinato ruolo.
   * @param {number} role - Il ruolo da verificare
   * @returns {boolean}
   */
  is(role) {
    return this.role === role;
  }
  isAny(roles) {
    return (this.role & roles) !== 0;
  }
  /**
   * Verifica se l'utente NON abbia un determinato ruolo.
   * @param {number} role - Il ruolo da verificare
   * @returns {boolean}
   */
  isNot(role) {
    return this.role !== role;
  }

  /**
   * Verifica se l'utente sia Admin.
   * @returns {boolean}
   */
  isAdmin() {
    return this.role === Role.ADMIN;
  }

  /**
   * Verifica se l'utente sia Student.
   * @returns {boolean}
   */
  isStudent() {
    return this.role === Role.STUDENT;
  }

  /**
   * Verifica se l'utente sia Teacher.
   * @returns {boolean}
   */
  isTeacher() {
    return this.role === Role.TEACHER;
  }

  /**
   * Verifica se l'utente sia Manager.
   * @returns {boolean}
   */
  isManager() {
    return this.role === Role.MANAGER;
  }

  /**
   * Verifica se l'utente sia ManagerCC.
   * @returns {boolean}
   */
  isManagerCC() {
    return this.role === Role.MANAGER_CC;
  }

  /**
   * Ottiene l'etichetta del ruolo.
   * @returns {string}
   */
  getLabel() {
    return Role.codeToLabel(this.role);
  }

  /**
   * Ottiene il valore numerico del ruolo.
   * @returns {number}
   */
  getValue() {
    return this.role;
  }
}
